import { useMutation } from 'react-query'

const baseUrl = `${import.meta.env.VITE_APP_BASE_API_URL}`

export const useLoginAsSite = () =>
  useMutation<void, Response, [string]>(async ([siteId]) => {
    const response = await fetch(baseUrl + `/login-as-site`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ site_id: siteId }),
    })

    if (!response.ok) throw response
  })

export const useSwitchBack = () =>
  useMutation<void, Response, null>(async () => {
    const response = await fetch(baseUrl + `/login-as-site`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    })

    if (!response.ok) throw response
  })
